import React from "react";
import { HashRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Login from "./Login";
import LocalStorageCleaner from "./Functions/LocalStorageCleaner";
import LandingPage from "./ASAP/LandingPage";
import LandingPageRep from "./MedRep/LandingPageRep";
import LandingPageWMS from "./WMS/LandingPageWMS";
import LandingPageOMS from "./WMS/LandingPageOMS";
import Client from "./ASAP/Client";
import EditClient from "./ASAP/EditClient";
import ClientAdd from "./ASAP/ClientAdd";
import ProductsASAP from "./ASAP/ProductsASAP";
import MoreInfo from "./ASAP/MoreInfo";
import Receipt from "./ASAP/Receipt";
import Statement from "./ASAP/Statement";
import Catalogs from "./ASAP/Catalogs";
import TransactionASAP from "./ASAP/TransactionASAP";
import List from "./ASAP/List";
import TransactionDetailASAP from "./ASAP/TransactionDetailASAP";
import firebase from "./firebase";
import Modules from "./Modules";
import Payment from "./ASAP/Payment";
import Products from "./MedRep/Products";
import AddVisit from "./MedRep/AddVisit";
import AddRoute from "./MedRep/AddRoute";
import Reports from "./MedRep/Reports";
import AddActivity from "./MedRep/AddActivity";
import HCPs from "./MedRep/HCPs";
import Plan from "./MedRep/Plan";
import HCPDetail from "./MedRep/HCPDetail";
import DailySchedule from "./MedRep/DailySchedule";
import Tracking from "./MedRep/Tracking";
import CoachingPlanner from "./MedRep/CoachingPlanner";
import AddClient from "./MedRep/AddClient";
import Transaction from "./WMS/Transaction";
import AddTransfer from "./WMS/AddTransfer";
import TransactionList from "./WMS/TransactionList";
import Packages from "./WMS/Packages";
import PackagesList from "./WMS/PackagesList";
import ItemsWMS from "./WMS/ItemsWMS";
import TransactionDetail from "./WMS/TransactionDetail";
import TransactionsPage from "./ASAP/TransactionsPage";
import Report from "./ASAP/Report";
import Purchase from "./ASAP/Purchase";
import Return from "./ASAP/Return";
import Delivery from "./ASAP/Delivery";
import Order from "./ASAP/Order";
import Signature from "./ASAP/Signature";
import Print from "./ASAP/Print";
import CashSales from "./ASAP/CashSales";
import PaymentCashSale from "./ASAP/PaymentCashSale";
import Journal from "./ASAP/Journal";
import UnsyTrans from "./ASAP/UnsyTrans";
import Log from "./ASAP/Log";
import Target from "./ASAP/Targeting";
import "./App.css";
import PrivateRoute from "./PrivateRoute";
import Reports2 from "./ASAP/Reports2";
import ReportsAsap from "./ASAP/Reports";
import "firebase/messaging";
import StatmentDetails from "./ASAP/StatmentDetails";
import SalesGauge from "./ASAP/SalesGauge";
import CompetitorDataLogger from "./ASAP/CompetitorDataLogger";
import {
  getLoginLandingRoute,
  hasActiveVisit,
  hasPendingCashInvoicePayment,
  isActiveVisitRouteBlocked,
} from "./Functions/LoginFlow";

const paths = [
  "/",
  "/Packages",
  "/PackagesList",
  "/LandingPage",
  "/LandingPageRep",
  "/Client",
  "/Order",
  "/Statement",
  "/Catalogs",
  "/Items",
  "/SalesOrderDetail",
  "/Payment",
  "/Modules",
  "/AddVisit",
  "/AddActivity",
  "/Products",
  "/HCPs",
  "/Plan",
  "/AddRoute",
  "/Reports",
  "/HCPDetail",
  "/DailySchedule",
  "/Tracking",
  "/AddClient",
  "/CoachingPlanner",
  "/LandingPageWMS",
  "/Transfer",
  "/AddTransfer",
  "/RequestDetail",
  "/List",
  "/ClientAdd",
  "/MoreInfo",
  "/EditClient",
  "/TransactionsPage",
  "/Report",
  "/ItemsWMS",
  "/Requests",
  "/Transfers",
  "/Packages",
  "/TransferDetail",
  "/Request",
  "/LandingPageOMS",
  "/ProductsASAP",
  "/Purchase",
  "/Return",
  "/Receipt",
  "/Signature",
  "/Delivery",
  "/Print",
  "/CashSales",
  "/PaymentCashSale",
  "/Journal",
  "/UnsyTrans",
  "/Log",
  "/Target",
  "/Reports2",
  "/ReportsAsap",
  "/StatmentDetails",
  "/SalesGauge",
  "/CompetitorDataLogger",
  
];

const components = [
  Login,
  Packages,
  PackagesList,
  LandingPage,
  LandingPageRep,
  Client,
  Order,
  Statement,
  Catalogs,
  TransactionASAP,
  TransactionDetailASAP,
  Payment,
  Modules,
  AddVisit,
  AddActivity,
  Products,
  HCPs,
  Plan,
  AddRoute,
  Reports,
  HCPDetail,
  DailySchedule,
  Tracking,
  AddClient,
  CoachingPlanner,
  LandingPageWMS,
  Transaction,
  AddTransfer,
  TransactionDetail,
  List,
  ClientAdd,
  MoreInfo,
  EditClient,
  TransactionsPage,
  Report,
  ItemsWMS,
  TransactionList,
  TransactionList,
  Transaction,
  TransactionDetail,
  Transaction,
  LandingPageOMS,
  ProductsASAP,
  Purchase,
  Return,
  Receipt,
  Signature,
  Delivery,
  Print,
  CashSales,
  PaymentCashSale,
  Journal,
  UnsyTrans,
  Log,
  Target,
  Reports2,
  ReportsAsap,
  StatmentDetails,
  SalesGauge
  ,
  CompetitorDataLogger
];

const intervalInDays = 15;

function App() {
  //React.useEffect(() => {
  //    const messaging = firebase.messaging();
  //    messaging.requestPermission().then(() => {
  //        return messaging.getToken();
  //    }).then((data) => {
  //        console.log(data);
  //    })
  //})

  const hasPendingCashInvoicePaymentFlag = () => {
    return hasPendingCashInvoicePayment();
  };

  const hasActiveVisitFlag = () => {
    return hasActiveVisit();
  };

  return (
    // <Router>
    //     <Switch>
    //         {paths.map((item, index) => {
    //             return (
    //                 <Route exact={true} path={item} component={components[index]} key={index} />
    //             )
    //         })
    //         }
    //     </Switch>
    //      <LocalStorageCleaner />
    // </Router>
    <Router>
      <Switch>
        {paths.map((path, index) => {
          const Component = components[index];
          return (
            <Route
              key={index}
              exact
              path={path}
              render={(props) => {
                if (path === "/") {
                  const token = localStorage.getItem("Token");
                  const isAuthenticated = !!token && token !== "null" && token !== '""';
                  if (isAuthenticated) {
                    const nextRoute = getLoginLandingRoute();
                    if (nextRoute !== "/Modules" && nextRoute !== "/") {
                      return <Redirect to={nextRoute} replace />;
                    }
                  }
                  return <Component {...props} />;
                }
                if (hasPendingCashInvoicePaymentFlag() && path !== "/Payment") {
                  return <Redirect to="/Payment" replace />;
                }
                if (hasActiveVisitFlag() && isActiveVisitRouteBlocked(path)) {
                  return <Redirect to={getLoginLandingRoute()} replace />;
                }
                return <PrivateRoute element={<Component {...props} />} />;
              }}
            />
          );
        })}
      </Switch>
      <LocalStorageCleaner />
    </Router>
  );
}

export default App;

// import React from "react";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import Login from "./Login";
// import LocalStorageCleaner from "./Functions/LocalStorageCleaner";
// import LandingPage from "./ASAP/LandingPage";
// import LandingPageRep from "./MedRep/LandingPageRep";
// import LandingPageWMS from "./WMS/LandingPageWMS";
// import LandingPageOMS from "./WMS/LandingPageOMS";
// import Client from "./ASAP/Client";
// import EditClient from "./ASAP/EditClient";
// import ClientAdd from "./ASAP/ClientAdd";
// import ProductsASAP from "./ASAP/ProductsASAP";
// import MoreInfo from "./ASAP/MoreInfo";
// import Receipt from "./ASAP/Receipt";
// import Statement from "./ASAP/Statement";
// import Catalogs from "./ASAP/Catalogs";
// import TransactionASAP from "./ASAP/TransactionASAP";
// import List from "./ASAP/List";
// import TransactionDetailASAP from "./ASAP/TransactionDetailASAP";
// import firebase from "./firebase";
// import Modules from "./Modules";
// import Payment from "./ASAP/Payment";
// import Products from "./MedRep/Products";
// import AddVisit from "./MedRep/AddVisit";
// import AddRoute from "./MedRep/AddRoute";
// import Reports from "./MedRep/Reports";
// import AddActivity from "./MedRep/AddActivity";
// import HCPs from "./MedRep/HCPs";
// import Plan from "./MedRep/Plan";
// import HCPDetail from "./MedRep/HCPDetail";
// import DailySchedule from "./MedRep/DailySchedule";
// import Tracking from "./MedRep/Tracking";
// import CoachingPlanner from "./MedRep/CoachingPlanner";
// import AddClient from "./MedRep/AddClient";
// import Transaction from "./WMS/Transaction";
// import AddTransfer from "./WMS/AddTransfer";
// import TransactionList from "./WMS/TransactionList";
// import Packages from "./WMS/Packages";
// import PackagesList from "./WMS/PackagesList";
// import ItemsWMS from "./WMS/ItemsWMS";
// import TransactionDetail from "./WMS/TransactionDetail";
// import TransactionsPage from "./ASAP/TransactionsPage";
// import Report from "./ASAP/Report";
// import Purchase from "./ASAP/Purchase";
// import Return from "./ASAP/Return";
// import Delivery from "./ASAP/Delivery";
// import Order from "./ASAP/Order";
// import Signature from "./ASAP/Signature";
// import Print from "./ASAP/Print";
// import CashSales from "./ASAP/CashSales";
// import PaymentCashSale from "./ASAP/PaymentCashSale";
// import Journal from "./ASAP/Journal";
// import UnsyTrans from "./ASAP/UnsyTrans";
// import Log from "./ASAP/Log";
// import Target from "./ASAP/Targeting";
// import PrivateRoute from "./PrivateRoute"; // Import the PrivateRoute component
// import "./App.css";

// const paths = [
//   "/",
//   "/Packages",
//   "/PackagesList",
//   "/LandingPage",
//   "/LandingPageRep",
//   "/Client",
//   "/Order",
//   "/Statement",
//   "/Catalogs",
//   "/Items",
//   "/SalesOrderDetail",
//   "/Payment",
//   "/Modules",
//   "/AddVisit",
//   "/AddActivity",
//   "/Products",
//   "/HCPs",
//   "/Plan",
//   "/AddRoute",
//   "/Reports",
//   "/HCPDetail",
//   "/DailySchedule",
//   "/Tracking",
//   "/AddClient",
//   "/CoachingPlanner",
//   "/LandingPageWMS",
//   "/Transfer",
//   "/AddTransfer",
//   "/RequestDetail",
//   "/List",
//   "/ClientAdd",
//   "/MoreInfo",
//   "/EditClient",
//   "/TransactionsPage",
//   "/Report",
//   "/ItemsWMS",
//   "/Requests",
//   "/Transfers",
//   "/Packages",
//   "/TransferDetail",
//   "/Request",
//   "/LandingPageOMS",
//   "/ProductsASAP",
//   "/Purchase",
//   "/Return",
//   "/Receipt",
//   "/Signature",
//   "/Delivery",
//   "/Print",
//   "/CashSales",
//   "/PaymentCashSale",
//   "/Journal",
//   "/UnsyTrans",
//   "/Log",
//   "/Target",
// ];

// const components = [
//   Login,
//   Packages,
//   PackagesList,
//   LandingPage,
//   LandingPageRep,
//   Client,
//   Order,
//   Statement,
//   Catalogs,
//   TransactionASAP,
//   TransactionDetailASAP,
//   Payment,
//   Modules,
//   AddVisit,
//   AddActivity,
//   Products,
//   HCPs,
//   Plan,
//   AddRoute,
//   Reports,
//   HCPDetail,
//   DailySchedule,
//   Tracking,
//   AddClient,
//   CoachingPlanner,
//   LandingPageWMS,
//   Transaction,
//   AddTransfer,
//   TransactionDetail,
//   List,
//   ClientAdd,
//   MoreInfo,
//   EditClient,
//   TransactionsPage,
//   Report,
//   ItemsWMS,
//   TransactionList,
//   Transaction,
//   LandingPageOMS,
//   ProductsASAP,
//   Purchase,
//   Return,
//   Receipt,
//   Signature,
//   Delivery,
//   Print,
//   CashSales,
//   PaymentCashSale,
//   Journal,
//   UnsyTrans,
//   Log,
//   Target,
// ];

// function App() {
//   return (
//     <Router>
//       <Switch>
//         {paths.map((item, index) => {
//           const Component = components[index];
//           return (
//             <PrivateRoute
//               exact
//               path={item}
//               element={<Component />}
//               key={index}
//             />
//           );
//         })}
//         {/* Optionally, add a route for the login page */}
//         <Route path="/login" component={Login} />
//       </Switch>
//       <LocalStorageCleaner />
//     </Router>
//   );
// }

// export default App;
